export function useSlug(path: string) {
    const segments = path.replace(/^\/|\/$/g, '').split('/')
    let locale = ['en', 'tr'].includes(segments[0]) ? segments.shift()! : 'tr'
  
    const rest = segments.join('/')
    let slug = rest.trim() || 'home' 
    const isTourDetail = slug.startsWith('tourDetail')
    const isQuiz = slug.startsWith('user/quiz')
    const isHotel = slug.startsWith('hotel/')
    const isPage = slug.startsWith('page/')
    const isIframe = slug.startsWith('iframe/')
    const isTour = slug.startsWith('tour/') 
    const isTours= slug.startsWith('tours/') 
    const isAdmin= slug.startsWith('admin/') 
    if (isAdmin ||  isTours || isTour || isTourDetail || isQuiz || isHotel || isIframe || isPage) {
      const parts = slug.split('/') 
      slug = parts[parts.length - 1] || slug
    }
  
  
    if (slug === 'yorumlar') slug = locale === 'en' ? 'comments' : 'yorumlar'
  
    return { locale, slug, isTourDetail, isQuiz, isHotel, isPage, isIframe }
  }
  